import React from 'react';
import { IconButton, Tooltip, useTheme } from '@mui/material';
import { Brightness4, Brightness7 } from '@mui/icons-material';
import { useThemeStore } from '../../stores/themeStore';

interface ThemeToggleProps {
  size?: 'small' | 'medium' | 'large';
}

/**
 * Simple theme toggle component for light/dark mode
 */
export const ThemeToggle: React.FC<ThemeToggleProps> = ({
  size = 'medium',
}) => {
  const theme = useTheme();
  const { mode, toggleMode } = useThemeStore();

  const handleToggle = () => {
    toggleMode();
  };

  const getIcon = () => {
    return mode === 'light' ? <Brightness4 /> : <Brightness7 />;
  };

  const getTooltip = () => {
    return `Switch to ${mode === 'light' ? 'dark' : 'light'} mode`;
  };

  return (
    <Tooltip title={getTooltip()}>
      <IconButton
        onClick={handleToggle}
        color="inherit"
        size={size}
        sx={{
          transition: theme.transitions.create(['transform', 'color'], {
            duration: theme.transitions.duration.short,
          }),
          '&:hover': {
            transform: 'rotate(90deg)',
          },
        }}
        data-testid="theme-toggle-button"
      >
        {getIcon()}
      </IconButton>
    </Tooltip>
  );
};
